<main class="page-container">
  @if (loading) {
    <app-loading [fullscreen]="true" label="Cargando usuarios..."></app-loading>
  }
  <app-page-header
    title="Usuarios de la empresa"
    description="Administra los accesos y roles de tu empresa"
  >
    <app-button type="button" variant="primary" (clicked)="nueva()"
      ><i class="fa-solid fa-plus"></i> Nuevo usuario</app-button
    >
  </app-page-header>

  @if (message) {
    <div class="notice success">{{ message }}</div>
  }
  @if (error) {
    <div class="notice error">{{ error }}</div>
  }

  <div class="summary-grid">
    <app-summary-card
      label="Usuarios activos"
      [value]="resumenData?.usuariosActivos?.toString() || null"
      icon="fa-solid fa-users"
      tone="blue"
    />
    <app-summary-card
      label="Usuarios inactivos"
      [value]="resumenData?.usuariosInactivos?.toString() || null"
      icon="fa-solid fa-user-slash"
      tone="warning"
    />
    <app-summary-card
      label="Administradores"
      [value]="resumenData?.administradores?.toString() || null"
      icon="fa-solid fa-user-shield"
      tone="green"
    />
    <app-summary-card
      label="Sin rol"
      [value]="resumenData?.usuariosSinRol?.toString() || null"
      icon="fa-solid fa-user-lock"
      tone="warning"
    />
  </div>

  <section class="data-section-card">
    <div class="toolbar">
      <input
        [(ngModel)]="search"
        (keyup.enter)="searchUsers()"
        placeholder="Buscar por nombre o usuario..."
      />
      <app-select
        [(ngModel)]="status"
        (valueChange)="searchUsers()"
        [options]="statusOptions"
      ></app-select>
      <app-button type="button" variant="outlined" (clicked)="searchUsers()">Buscar</app-button>
    </div>
    @if (mobileService.isMobile()) {
      <app-card-list
        [items]="usuarios"
        [loading]="loading"
        [emptyMessage]="'No hay usuarios para los filtros seleccionados.'"
        [page]="page"
        [pageSize]="pageSize"
        [totalItems]="totalItems"
        [pageSizeOptions]="[10, 25, 50, 100]"
        [showPagination]="true"
        [showPageSize]="true"
        (pageChange)="onPageChange($event)"
        (pageSizeChange)="onPageSizeChange($event)"
      >
        <ng-template #card let-usuario>
          <div class="card-list-item empresa-user-card">
            <div class="card-list-item-header">
              <div class="user-card-identity">
                <strong>{{ usuario.nombre }}</strong>
                <span>{{ usuario.usuario }}</span>
              </div>
              <span [class]="'badge ' + getBadgeClass(usuario.estado)">
                <span class="badge-dot"></span>{{ usuario.estado }}
              </span>
            </div>
            <div class="card-list-item-body">
              <div class="card-list-item-details">
                <span class="card-list-item-label"
                  >Roles: <span class="card-list-item-value">{{ roleLabel(usuario) }}</span></span
                >
                <span class="card-list-item-label"
                  >Registro:
                  <span class="card-list-item-value">{{
                    usuario.fechaCreacion | date: 'dd/MM/yyyy'
                  }}</span></span
                >
              </div>
            </div>
            <div class="card-list-item-actions">
              <app-button
                type="button"
                variant="outlined"
                size="small"
                [disabled]="isCurrentUser(usuario)"
                (clicked)="editar(usuario)"
              >
                <i class="fa-solid fa-pen-to-square"></i> Editar
              </app-button>
              <app-button
                type="button"
                variant="outlined"
                size="small"
                [disabled]="isCurrentUser(usuario)"
                (clicked)="toggle(usuario)"
              >
                <i class="fa-solid fa-power-off"></i>
                {{ usuario.estado === 'ACTIVO' ? 'Desactivar' : 'Activar' }}
              </app-button>
              <app-button
                type="button"
                variant="outlined"
                size="small"
                (clicked)="resetPassword(usuario)"
              >
                <i class="fa-solid fa-key"></i> Contraseña
              </app-button>
            </div>
          </div>
        </ng-template>
      </app-card-list>
    } @else {
      <app-data-table-paginado
        [columns]="columns"
        [data]="usuarios"
        [loading]="loading"
        [emptyMessage]="'No hay usuarios para los filtros seleccionados.'"
        [page]="page"
        [pageSize]="pageSize"
        [totalItems]="totalItems"
        [pageSizeOptions]="[10, 25, 50, 100]"
        [showPagination]="true"
        [showPageSize]="true"
        [showRowHover]="true"
        (pageChange)="onPageChange($event)"
        (pageSizeChange)="onPageSizeChange($event)"
        (sortChange)="onSort($event)"
        (action)="onAction($event)"
      />
    }
  </section>

  @if (showForm) {
    <app-modal-shell title="" [showHeader]="false" size="medium" (closed)="closeForm()">
      <div class="modal-form">
        <h2>{{ editing ? 'Editar usuario' : 'Nuevo usuario' }}</h2>
        @if (formError) {
          <div class="notice error modal-error">{{ formError }}</div>
        }
        <label>Nombre<input [(ngModel)]="form.nombre" /></label>
        <label>Usuario<input [(ngModel)]="form.usuario" [disabled]="!!editing" /></label>
        @if (!editing) {
          <label>Contraseña<input type="password" [(ngModel)]="form.password" /></label>
        }
        <fieldset>
          <legend>Roles</legend>
          @for (role of roles; track role.id) {
            <label class="role"
              ><input
                type="checkbox"
                [checked]="form.rolIds.includes(role.id)"
                (change)="toggleRole(role.id, $event)"
              />
              {{ role.nombre }}</label
            >
          }
        </fieldset>
        <div class="modal-actions">
          <app-button type="button" variant="outlined" (clicked)="closeForm()">Cancelar</app-button>
          <app-button type="button" variant="primary" [disabled]="saving" (clicked)="guardar()"
            >Guardar</app-button
          >
        </div>
      </div>
    </app-modal-shell>
  }

  @if (showPasswordModal && pendingStatusUser) {
    <app-modal-shell
      title="Cambiar contraseña"
      description="Define una nueva contraseña para el usuario."
      (closed)="closePasswordModal()"
    >
      <div class="modal-form">
        <p>
          Usuario: <strong>{{ pendingStatusUser.nombre }}</strong>
        </p>
        @if (passwordError) {
          <div class="notice error modal-error">{{ passwordError }}</div>
        }
        <label>Nueva contraseña<input type="password" [(ngModel)]="passwordValue" /></label>
        <div class="modal-actions">
          <app-button type="button" variant="outlined" (clicked)="closePasswordModal()"
            >Cancelar</app-button
          >
          <app-button type="button" variant="primary" [disabled]="saving" (clicked)="savePassword()"
            >Guardar</app-button
          >
        </div>
      </div>
    </app-modal-shell>
  }

  @if (showStatusConfirmation && pendingStatusUser) {
    <app-confirmation-modal
      [title]="pendingStatusUser.estado === 'ACTIVO' ? 'Desactivar usuario' : 'Activar usuario'"
      [message]="
        pendingStatusUser.estado === 'ACTIVO'
          ? 'El usuario no podrá iniciar sesión mientras esté inactivo.'
          : 'El usuario podrá volver a iniciar sesión.'
      "
      [confirmLabel]="pendingStatusUser.estado === 'ACTIVO' ? 'Desactivar' : 'Activar'"
      [status]="confirmationStatus"
      [processing]="processingStatus"
      [autoClose]="true"
      [successTitle]="'Estado actualizado'"
      [errorTitle]="'No se pudo actualizar el estado'"
      (confirmed)="confirmStatusChange()"
      (cancelled)="closeStatusConfirmation()"
      (closed)="closeStatusConfirmation()"
    />
  }
</main>
